import React from 'react';
import { DirectoryModal } from './DirectoryModal';
import { DirectoryModalContent } from './DirectoryModalContent';
import { RelationStatus, WP_UserNetwork } from '../../model/models';
import { DirectoryIcon } from './DirectoryIcon';
import {
  CreateUserNetworkFunc,
  DeleteUserNetworkFunc,
  UpdateUserNetworkFunc,
} from '../../hooks/WPHooks';
import { RefreshDirUserFunc } from '../../hooks/DirectoryHooks';

export interface DirectoryProps {
  userId: number;
  name: string;
  house: string;
  avatar: string;
  phone: string;
  email: string;
  network: WP_UserNetwork | undefined;
  friendStatus: RelationStatus;
  backUrl?: string;
  create: CreateUserNetworkFunc;
  update: UpdateUserNetworkFunc;
  remove: DeleteUserNetworkFunc;
  refreshUser: RefreshDirUserFunc;
}

export const DirectoryItem: React.FC<DirectoryProps> = (props) => (
  <li className="relative border-b border-gray-200 py-5 flex items-center space-x-3 focus:bg-primary md:border-0 md:rounded-2xl md:flex-col md:bg-white md:p-5">
    <DirectoryModal
      backUrl={props.backUrl || '/directory'}
      content={<DirectoryModalContent {...props} />}
    >
      <div className="flex-shrink-0 md:mb-4 md:relative">
        <div className="h-12 w-12 md:h-20 md:w-20">
          <img
            className="rounded-full object-cover"
            src={props.avatar}
            style={{ height: '100%', width: '100%' }}
            alt=""
          />
        </div>
        <div className="hidden md:block md:absolute md:-right-2 md:top-0">
          <DirectoryIcon friendStatus={props.friendStatus} />
        </div>
      </div>
      <div className=" w-full flex-1 min-w-0 text-left pl-2 md:pl-0 md:text-center">
        <span className="absolute inset-0" aria-hidden="true" />
        <p className="text-sm font-medium text-gray-900 md:mb-1">
          {props.name}
        </p>
        <p className="text-xs text-gray-500">{props.house}</p>
      </div>
      <div className="md:hidden">
        <DirectoryIcon friendStatus={props.friendStatus} />
      </div>
    </DirectoryModal>
  </li>
);
